export const TOURPROJECTLISTVIEW = {
    switchbetween: {
        intro: 'Switch between Projects, Companies and People search',
        position: "top",
        class: "cd-switch-info"
    },
    selectorcontrol: {
        intro: '<ul><li>Select projects to perform an action, such as favourite, tag or download PDF </li><li> See the search results count</li></ul>',
        position: "bottom",
        class: "cd-sc-info"
    },
    performsearch: {
        intro: 'Enter a keyword to perform a fuzzy search',
        position: "top",
        class: "cd-perfsrc-info"
    },
    resultcount: {
        intro: 'See the search results count',
        position: "right"
    },
    listview: {
        intro: '<ul><li>Click to visit the project details page</li><li>See your activities on this project</li></ul>',
        position: "bottom",
        class: "cd-listview-info"
    },
    seeproject: {
        intro: 'Click on the arrow to see the companies working on this project',
        position: 'top',
        class: "cd-seeproj-info"
    },
    addresspostcode: {
        intro: '<ul><li>Start typing an address or postcode to select a location from a list </li><li> Select a radius – default is 25 miles </li><li> Choose current location</li></ul>',
        position: "bottom",
        class: "cd-addpostcode-info",
    },
    listmapview: {
        intro: 'Switch between list and map view',
        position: "bottom",
        class: "cd-listmapview-info"
    },
    radius: {
        intro: 'Select a radius – default is 25 miles',
        position: "top"
    },
    currentloc: {
        intro: 'Choose current location',
        position: "top"
    },
    sortorder: {
        intro: 'Choose a sort order',
        position: "bottom",
        class: "cd-sortorder-info"
    },
    morefilters: {
        intro: 'Click to apply more filters',
        position: "top",
        class: "cd-filterbtn-info"
    },
    runsearch: {
        intro: 'Run the search',
        position: "top",
        class: "cd-runsrc-info"
    },
    savesrc: {
        intro: 'Save the search to run again',
        position: "bottom",
        class: "cd-savesrc-info"
    },
}

export const TOURCOMPANYLISTVIEW = {
    listview: {
        intro: '<ul><li>Click to visit the company details page</li><li>See your activities on this company</li></ul>',
        position: "bottom",
        class: "cd-listview-info"
    },
    seecompany: {
        intro: 'Click the arrow to see projects this company is working on',
        position: 'top',
        class: "cd-seeproj-info"
    },
    selectorcontrol: {
        intro: '<ul><li>Select company to perform an action, such as favourite, tag or download PDF </li><li> See the search results count</li></ul>',
        position: "bottom",
        class: "cd-sc-info"
    }
}

export const TOURCOMPANYMAPVIEW = {
    seecompany: {
      intro: 'Click the arrow to see projects this company is working on',
      position: 'bottom',
      class: "cd-mapview-seeproj-info"
    }
  }
  export const TOURPROJECTMAPVIEW = {
    searchhere: {
      intro: 'Click to search around the position of the map',
      position: "top"
    },
    seeproject: {
      intro: 'Click on the arrow to see the companies working on this project',
      position: 'bottom',
      class: "cd-mapview-seeproj-info"
    },
    maptoolbar: {
      intro: '<div class="d-flex flex-column"> <div class="d-flex flex-row align-items-top mb-0"><span class="w-30px mr-2 font-weight-bold p-0 h3 text-center m-0">+</span> <span class="align-self-center">Zoom in </span></div><div class="d-flex flex-row align-items-top mb-0"><span class="w-30px mr-2 font-weight-bold p-0 h3 text-center m-0">-</span> <span class="align-self-center">Zoom out </span></div><div class="d-flex flex-row align-items-top mb-0"><span class="w-30px mr-2"><i class="icon-placeholder ico-curloc"></i></span> <span class="align-self-center">Search at current location </span></div><div class="d-flex flex-row align-items-top mb-0"><span class="w-30px mr-2"><i class="icon-placeholder ico-sat"></i></span> <span class="align-self-center">Switch between satellite and map view </span> </div></div>',
      position: "bottom",
      class: "cd-maptoolbar-info"
    }
  }
  
  
  export const TOURFILTERVIEW = {
    selectfilter: {
      intro: 'Click on each section in the left menu to refine your search',
      position: "top"
    },
    filtercolumn: {
      intro: 'Apply your filter settings in this panel. You can scroll down to browse all filters',
      position: "top"
    },
    clearall: {
      intro: 'Click to clear the applied filters',
      position: "top",
      class: "cd-clearall-info"
    },
    closepanel: {
      intro: 'Click to close and return to the search page',
      position: "bottom",
      class: "cd-close-info"
    },
    summarypanel: {
      intro: 'Here you will see a summary of the filters you have applied',
      position: "left",
      class: "cd-summarypanel-info"
    },
    projectcompanycount: {
      intro: 'Project and company counts will update as you apply or remove filters. Click either ‘View projects’ or ‘View companies’ when you are happy with your selection',
      position: "top"
    },
  
  
  }
  export const TOURSAVEDSEARCH = {
    newsearch: {
      intro: 'Go back to the main search screen and perform a new search',
      position: "left",
      class: "cd-newsrc-info"
    },
    notification: {
      intro: 'See notifications of your updates and visit the account menu for Settings, Favourite roles and other features',
      position: "left",
      class: "cd-notification-info"
    },
    account: {
      intro: 'Visit the account menu for Settings, Favourite roles and other features',
      position: "left"
    },
    title: {
      intro: '<div class="mb-2">This is the title of your saved search. Click anywhere in the box to run the saved search </div> <div class="d-flex flex-column"> <div class="mb-2">The icon identifies the type of saved search:</div> <div class="d-flex flex-row"><div class="d-flex flex-row align-items-center mb-0"><span class="w-30px mr-2"><i class="icon-placeholder ico-projectss"></i></span><span class="align-self-center">  Project saved search</span></div> <div class="d-flex flex-row align-items-center mb-0"><span class="w-30px mr-2"><i class="icon-placeholder ico-companyss"></i></span><span class="align-self-center">  Company saved search</span></div> <div class="d-flex flex-row align-items-center mb-0"><span class="w-30px mr-2"><i class="icon-placeholder ico-contactss"></i></span><span class="align-self-center">  People saved search</span></div></div> </div>',
      position: "right",
      class: "cd-title-info"
    },
    types: {
      intro: 'This icon identifies the type of saved search:<ul><li>[Project icon] - Project saved search</li><li>[Company icon] - Company saved search</li><li>[People icon] - People saved search</li></ul>',
      position: "right"
    },
    filteroptions: {
      intro: 'Here you will see a summary of the filters in your saved search',
      position: "bottom",
      class: "cd-filteroptions-info"
    },
    toolbar: {
      intro: '<div class="d-flex flex-column"> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-src"></i></span> <span class="align-self-center"><strong>Search</strong> Go back to the main search screen</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-savedsrc"></i></span> <span class="align-self-center"><strong>Saved search</strong>  View your saved searches to run them again, share or create a feed</span> </div><div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-league"></i></span> <span class="align-self-center"><strong>League table</strong>  Create a list of the most active companies or those on the biggest projects you want to target</span> </div>  <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-myleads"></i></span> <span class="align-self-center"><strong>My leads</strong>  View projects and companies you have viewed, favourited, shared, tagged or added a note to</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-export"></i></span> <span class="align-self-center"><strong>Export</strong>  Create a CSV data file from a saved search or tag. You can then produce a mail merge</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-teams"></i></span> <span class="align-self-center"><strong>Teams</strong>  Manage users and teams to easily share projects and companies</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-admin"></i></span> <span class="align-self-center"><strong>Admin</strong>  Assign licences to users and see user activity report</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-chat"></i></span> <span class="align-self-center"><strong>Chat with us</strong>  Send any queries to one of the team</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-help"></i></span> <span class="align-self-center"><strong>Help</strong>  View our Help Centre articles</span> </div> </div>',
      position: "right",
      class: "cd-toolbar-info"
    },
    toolbarOpening: {
      intro: '<div class="d-flex flex-column"> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-src"></i></span> <span class="align-self-center"><strong>Search</strong> Go back to the main search screen</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-savedsrc"></i></span> <span class="align-self-center"><strong>Saved search</strong>  View your saved searches to run them again, share or create a feed</span> </div><div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-myleads"></i></span> <span class="align-self-center"><strong>My leads</strong>  View projects and companies you have viewed, favourited, shared, tagged or added a note to</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-export"></i></span> <span class="align-self-center"><strong>Export</strong>  Create a CSV data file from a saved search or tag. You can then produce a mail merge</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-teams"></i></span> <span class="align-self-center"><strong>Teams</strong>  Manage users and teams to easily share projects and companies</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-admin"></i></span> <span class="align-self-center"><strong>Admin</strong>  Assign licences to users and see user activity report</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-chat"></i></span> <span class="align-self-center"><strong>Chat with us</strong>  Send any queries to one of the team</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-help"></i></span> <span class="align-self-center"><strong>Help</strong>  View our Help Centre articles</span> </div> </div>',
      position: "right",
      class: "cd-toolbar-info"
    },
    actionbutton: {
      intro: '<div class="d-flex flex-column"> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-feed"></i></span> <span class="align-self-center">Create a feed for the saved search </span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-default"></i></span> <span class="align-self-center">Set the saved search as default so it runs automatically when you next sign in </span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-edit"></i></span> <span class="align-self-center">Edit the saved search. This takes you to the search results screen </span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-share"></i></span> <span class="align-self-center">Share the saved search with another user or team </span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-delete"></i></span> <span class="align-self-center">Delete the saved search</span> </div> </div>',
      position: "bottom",
      class:"cd-actionbutton-info"
    }
  }
  export const PROJECTDETAILS = {
    prevnext: {
      intro: '<div class="d-flex flex-row"> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-back"></i></span> <span class="align-self-center">Go back to the search results list</span> </div> <div class="d-flex flex-row align-items-top mb-0 ml-2"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-prev"></i></span> <span class="align-self-center">See previous project</span> </div> <div class="d-flex flex-row align-items-top mb-0 ml-2"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-next"></i></span> <span class="align-self-center">See next project</span> </div> </div>',
      position: "top",
      class: "cd-nextprev-info"
    },
    useractivities: {
      intro: '<div class="d-flex flex-column"> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-calendar"></i></span> <span class="align-self-center">Add a calendar event</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-fav"></i></span> <span class="align-self-center">Favourite the project</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-tag"></i></span> <span class="align-self-center">Tag the project</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-share"></i></span> <span class="align-self-center">Share the project with a user or team</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-note"></i></span> <span class="align-self-center">Add a note to the project</span> </div><div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-archive"></i></span> <span class="align-self-center">Archive the project</span> </div> </div>',
      position: "bottom",
      class: "cd-useractivities-info"
    },
    metadata: {
      intro: 'View key project information such as published date, value, project reference and which member of our research team is managing the project',
      position: "top",
      class: "cd-metadata-info"
    },
    enquiry: {
      intro: 'Send an enquiry to our<br/> research team ',
      position: "right",
      class: "cd-enquiry-info"
    },
    printview: {
      intro: ' See a print view of the project to save as PDF or print',
      position: "top",
      class: "cd-printview-info"
    },
    projectimage: {
      intro: 'View project image (if available) and map',
      position: "bottom"
    },
    tabs: {
      intro: '<div class="d-flex flex-column"> <div class="mb-0"> <strong>Details tab -  </strong>Click to see further details about the project such as timing, materials and categories </div> <div class="mb-0"> <strong>Roles &amp; Companies tab - </strong>Click to see the companies and roles on the project </div> <div class="mb-0"> <strong>Updates tab - </strong>Click to see project updates</div> <div class="mb-0"> <strong>Activities tab - </strong>Click to see activities such as notes, shares and tags. You can see other users’ activity in the Collaboration tab</div> <div class="mb-0"> <strong>Map tab - </strong>Click to see a map and get directions to the project address</div> </div>',
      position: "bottom",
      class: "cd-tabs-info"
    },
  }
  
  export const COMPANYDETAILS = {
  
    prevnext: {
      intro: '<div class="d-flex flex-row"> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-back"></i></span> <span class="align-self-center">Go back to the search results list</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-prev"></i></span> <span class="align-self-center">See previous company</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-next"></i></span> <span class="align-self-center">See next company</span> </div> </div>',
      position: "bottom",
      class: "cd-nextprev-info"
    },
    useractivities: {
      intro: '<div class="d-flex flex-column"> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-calendar"></i></span> <span class="align-self-center">Add a calendar event</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-fav"></i></span> <span class="align-self-center">Favourite the company</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-tag"></i></span> <span class="align-self-center">Tag the company</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-share"></i></span> <span class="align-self-center">Share the company with a user or team</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2"><i class="icon-placeholder ico-note"></i></span> <span class="align-self-center">Add a note to the company</span> </div> </div>',
      position: "bottom",
      class: "cd-couseractivities-info"
    },
    metadata: {
      intro: 'View key company information such as published date, project and value',
      position: "top",
      class: "cd-metadata-info"
    },
    enquiry: {
      intro: 'Send an enquiry to our<br/> research team ',
      position: "right",
      class: "cd-enquiry-info"
    },
    printview: {
      intro: ' See a print view of the company to save as PDF or print',
      position: "top",
      class: "cd-printview-info"
    },
    companyimage: {
      intro: 'View map image',
      position: "bottom",
      class: "cd-comapview-info"
    },
    tabs: {
      intro: '<div class="d-flex flex-column"> <div class="mb-0"> <strong>People tab - </strong>Click to see people working at the company </div> <div class="mb-0">  <strong>Projects tab - </strong>Click to see the projects the company has worked on </div> <div class="mb-0">  <strong>Relationships tab - </strong>Click to see other companies they work with, optionally by role, and see the joint projects </div> <div class="mb-0">  <strong>Works with companies tab - </strong>Click to see other companies they work with </div> <div class="mb-0">  <strong>Updates tab - </strong>Click to see company updates </div> <div class="mb-0">  <strong>Activities tab - </strong>Click to see activities such as notes, shares and tags. You can see other users’ activity in the Collaboration tab </div> <div class="mb-0">  <strong>Group companies tab - </strong>Click to see the Head Office and Subsidiary companies </div> <div class="mb-0">  <strong>Map tab - </strong>Click to see a map and get directions to the company address </div> </div>',
      position: "bottom",
      class: "cd-cotabs-info"
    },
  }
  
  export const PERSONDETAILS = {
  
    prevnext: {
      intro: '<div class="d-flex flex-row"> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-back"></i></span> <span class="align-self-center">Go back to the search results list</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-prev"></i></span> <span class="align-self-center">See previous person</span> </div> <div class="d-flex flex-row align-items-top mb-0"> <span class="w-30px mr-2 align-self-center"><i class="icon-placeholder ico-next"></i></span> <span class="align-self-center">See next person</span> </div> </div>',
      position: "bottom",
      class: "cd-nextprev-info"
    }
  }